import {Games, Scenarios} from "./models.js";

function Scenario() {
    // Strings
    const name = null;
    const description = null;
    const creator = null;
    const comments = null;

    // Integer
    const version = null;
    const editVersion = null;

    // Boolean
    const softDelete = false;
    const edit = false;

    // Arrays
    const contributorScenarios = [];

    // Foreign keys
    const originalScenarioId = null;

    return {
        name,
        description,
        creator,
        comments,
        version,
        softDelete,
        contributorScenarios,
        originalScenarioId,
        edit,
        editVersion,
    };
}

function getScenarioChildren(scenario) {
    return Scenarios.find({'originalScenarioId': scenario.$loki});
}

function addScenarioChildren(scenario, scenarios) {
    scenarios.forEach(c => {
        c.originalScenarioId = scenario.$loki
    });
}

function removeScenarioChildren(scenario, scenarios) {
    scenarios.forEach(c => {
        c.originalScenarioId = null
    });
}

function getScenarioParent(scenario) {
    return Scenarios.find({'$loki': scenario.originalScenarioId})[0];
}

function getScenarioGame(scenario) {
    return Games.find({'scenarioId': scenario.$loki})[0];
}

function setScenarioGame(scenario, game) {
    game.scenarioId = scenario.$loki;
}

function removeScenarioGame(scenario, game) {
    game.scenarioId = null;
}

export { Scenario, getScenarioChildren, addScenarioChildren, removeScenarioChildren, getScenarioParent,
    getScenarioGame, setScenarioGame, removeScenarioGame };